import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { api, formatIDR, formatApiError } from "../lib/api";
import ReceiptPanel from "../components/ReceiptPanel";
import { Button } from "../components/ui/button";

export default function TransactionDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [tx, setTx] = useState(null);
    const [error, setError] = useState("");
    const [revision, setRevision] = useState(0);


    useEffect(() => {
        const controller = new AbortController();
        setTx(null); setError("");
        api.get(`/transactions/${id}`, { signal: controller.signal }).then(({ data }) => setTx(data)).catch((err) => { if (!controller.signal.aborted) setError(formatApiError(err)); });
        return () => controller.abort();
    }, [id, revision]);

    if (error) return <div role="alert" className="rounded-2xl border border-destructive/30 p-5 space-y-3">
        <h1 className="font-heading font-bold">Transaksi tidak dapat dimuat</h1>
        <p className="text-sm text-destructive">{error}</p><Button onClick={() => setRevision((value) => value + 1)}>Coba lagi</Button><Button variant="ghost" onClick={() => navigate("/riwayat")}>Kembali ke riwayat</Button></div>;

    if (!tx) return (
        <div className="flex justify-center py-20">
            <div className="h-8 w-8 rounded-full border-2 border-brand-green border-t-transparent animate-spin" />
        </div>
    );

    const status = String(tx.status).toUpperCase();
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-3">
                <Button variant="ghost" size="icon" className="rounded-full" onClick={() => navigate(-1)} data-testid="detail-back-btn">
                    <ArrowLeft className="h-5 w-5" />
                </Button>
                <h1 className="font-heading font-bold text-xl tracking-tight">Detail Transaksi</h1>
            </div>

            <ReceiptPanel transaction={tx} />
            {tx.marginAmount != null && <div className="rounded-xl border border-border p-4 text-sm"><Row k="Margin akun Anda" v={formatIDR(tx.marginAmount)} /><p className="text-xs text-muted-foreground mt-2">Informasi ini tidak disertakan pada bukti yang dibagikan.</p></div>}

            {["PENDING", "PROCESSING"].includes(status) && <Button variant="outline" className="w-full" onClick={() => setRevision((value) => value + 1)}><RefreshCw className="h-4 w-4 mr-2" />Perbarui status</Button>}

        </div>
    );
}

function Row({ k, v, highlight, small }) {
    return (
        <div className="flex justify-between gap-3">
            <span className="text-muted-foreground">{k}</span>
            <span className={`font-semibold text-right break-words min-w-0 ${small ? "text-xs break-all" : ""} ${highlight ? "text-brand-green" : ""}`}>{v ?? "—"}</span>
        </div>
    );
}
